export const EXTERNAL_URLS = {
  salesContactForm: 'https://info.jwplayer.com/contact-us/',
  languageCodesList: 'https://www.loc.gov/standards/iso639-2/php/code_list.php',
  inplayerTerms: 'https://inplayer.com/legal/terms',
  jwpApps: 'https://jwplayer.com/ott-video-apps/',
  jwpContentTypes: 'https://docs.jwplayer.com/platform/docs/add-a-content-type',
  jwpDefaultContentTypes:
    'https://raw.githubusercontent.com/jwplayer/ott-web-app/release/scripts/content-types/content-types.json',
  appsMonetization: 'https://docs.jwplayer.com/platform/docs/apps-monetize-apps-with-ads',
  pageHeaderEditing: 'https://releases.jwplayer.com/media-item-naming-1hhREk',
} as const;

export const JW_DOCS_URLS = {
  jwpContentTypes: 'https://docs.jwplayer.com/platform/docs/add-a-content-type',
  jwpContentTypeLive: 'https://docs.jwplayer.com/platform/docs/add-a-live-channel',
} as const;
